export default __webpack_public_path__ + "static/media/Teams-Error.61e9ccca.png";